import React, { useMemo, useState, useRef, useEffect } from 'react';
import type { FC } from 'react';
import cls from 'classnames';

import styles from './index.module.scss';

export const LoadingMessageItem = () => {
  const [loadingLeftPos, setLoadingLeftPos] = useState<number>(0);

  const timer = useRef<any>();

  useEffect(() => {
    return () => {
      timer.current && clearTimeout(timer.current);
    };
  }, []);

  const positionStyle = useMemo(() => {
    return { backgroundPositionX: `${loadingLeftPos}px` };
  }, [loadingLeftPos]);

  const step = () => {
    timer.current && clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      const nextLeftPos = loadingLeftPos + 24;
      if (nextLeftPos > 886) {
        setLoadingLeftPos(0);
      } else {
        setLoadingLeftPos(nextLeftPos);
      }

      step();
    }, 42);
  };

  step();

  return (
    <div id={'loading-message'} className={cls([styles.message, styles.loading])}>
      <div className={styles.ani} style={positionStyle}></div>
    </div>
  );
};
